import React from "react";
import styled from "styled-components";

import {
  AlmahaImg,
  Qrcode,
  MahaScreens,
  BookFooter,
  PlayStore,
  AppStore,
  GooglePlayFooter,
  AppleStoreFooter,
} from "../assets/images";
import DownloadApp from "./SuccessfulBooking/DownloadApp";
import { Colors } from "../ColorConstants";
import { Text } from "../TextConstants";

const Footer = () => {
  return (
    <StyledFooter>
      <FooterContent>
        <FooterLeft>
          <FooterImage src={AlmahaImg} alt="Your Image Alt Text" />
          <FooterText>
            Copyright ©{" "}
            <FooterSubText>2023. All rights reserved by Al Maha.</FooterSubText>{" "}
            | - Powered by <FooterSubText>PIH</FooterSubText>
          </FooterText>
          <VersionText>{Text.version} 3.0.0</VersionText>
        </FooterLeft>
        <FooterQRCode src={Qrcode} alt="QR Code" />
        <DownloadFooter>
          <DownloadTitleText>{Text.downloadApp}</DownloadTitleText>
          <StoreImages>
            <a href="https://play.google.com/store/apps/details?id=com.estithmarholding.almahaisland&hl=en_ZA&gl=US">
              <StoreImage src={GooglePlayFooter} alt="Play Store" />
            </a>
            <a href="https://apps.apple.com/app/apple-store/id6443964600?pt=118552829&ct=Al%20Maha%20App%20Download&mt=8">
              <StoreImage src={AppleStoreFooter} alt="App Store" />
            </a>
          </StoreImages>
        </DownloadFooter>
      </FooterContent>
    </StyledFooter>
  );
};

export const FooterMobile = () => {
  return (
    <StyledFooterMobile>
      <FooterImage src={AlmahaImg} alt="Your Image Alt Text" style={{width: "50%"}}/>
      <FooterText style={{marginTop: "0.2rem"}}>
        Copyright ©{" "}
        <FooterSubText>2023. All rights reserved by Al Maha.</FooterSubText> | -
        Powered by <FooterSubText>PIH</FooterSubText>
      </FooterText>
    </StyledFooterMobile>
  );
};

export default Footer;

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url(${BookFooter});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin-top: 1rem;
  z-index: -1;
`;
const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  padding: 0rem 1rem;
  @media (max-width: 700px) {
    flex-direction: column;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }
  position: relative;
  z-index: 50;
`;

const FooterText = styled.span`
  font-family: Poppins;
  font-weight: 400;
  font-size: 0.7rem;
  text-align: center;
  color: ${Colors.davyGrey};
  @media (min-width: 700px) {
    flex-direction: row;
  }
`;

const FooterImage = styled.img`
  width: 60%;
  margin-bottom: 0.5rem;
`;

const FooterSubText = styled(FooterText)`
  font-weight: 700;
  //   padding: 0;
`;
const VersionText = styled.span`
  font-weight: 500;
  font-size: 0.8rem;
  padding-top: 0.5rem;
  color: ${Colors.grey};
`;

const FooterQRCode = styled.img`
  width: 50%;
  max-width: 8rem;
  padding: 1rem;
  @media (max-width: 700px) {
    max-width: 6rem;
  }
`;

const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 700px) {
    z-index: 1;
  }
`;
const StoreImages = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;

  @media (min-width: 700px) {
    flex-direction: row;
  }
`;

const StoreImage = styled.img`
  width: 200px;
  margin-left: 0rem;
  @media (min-width: 700px) {
    margin-bottom: 2rem;
    margin-left: 1rem;
  }
`;

const DownloadTitleText = styled.span`
  color: ${Colors.white};
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  @media (max-width: 700px) {
    font-size: 0.938rem;
  }
`;
const DownloadFooter = styled.span`
  flex-direction: column;
`;

//mobile
const StyledFooterMobile = styled.div`
  display: none;
  @media (max-width: 576px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${Colors.black};
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    margin-top: 1rem;
    z-index: -1;
    padding: 1rem 0.5rem 1rem 0.5rem;
  }
`;
